export default __webpack_public_path__ + "static/f5-20d41395c43ab75311fc846b487e166c.png";